module.exports = __webpack_public_path__ + "static/media/physical_mental_walking.da4b3920.jpg";